/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureEaSubscription extends models.ServiceAccountNativeDetailsBaseForAzureSubscription {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureEaSubscription");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureEaSubscription.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureEaSubscription>): ServiceAccountNativeDetailsForAzureEaSubscription {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureEaSubscription(), model);
        ServiceAccountNativeDetailsForAzureEaSubscription.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureEaSubscription>): ServiceAccountNativeDetailsForAzureEaSubscription {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureEaSubscription.newInstance(<ServiceAccountNativeDetailsForAzureEaSubscription> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureEaSubscription) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureEaSubscription.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureEaSubscription): boolean {
        if (models.ServiceAccountNativeDetailsBaseForAzureSubscription.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureEaSubscription.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
